<!-- Bar search -->
@if (appearance === 'bar') {
  @if (!opened) {
    <button mat-icon-button aria-label="Open search" (click)="open()">
      <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
    </button>
  }

  @if (opened) {
    <div class="bg-card absolute inset-0 z-99 flex shrink-0 items-center" @slideInTop @slideOutTop>
      <mat-icon class="absolute ml-6 sm:ml-8" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>

      <input
        class="h-full w-full px-16 sm:px-18"
        [formControl]="searchControl"
        [matAutocomplete]="matAutocomplete"
        [placeholder]="'Search...'"
        (keydown)="onKeydown($event)"
        #barSearchInput
      />

      <mat-autocomplete
        class="max-h-128 rounded-b border-t shadow-md sm:px-2"
        [autoSelectActiveOption]="true"
        [disableRipple]="true"
        #matAutocomplete="matAutocomplete"
      >
        @if (resultSets && !resultSets.length) {
          <mat-option class="text-secondary pointer-events-none bg-transparent px-6 py-0 text-md">No results found!</mat-option>
        }

        @if (resultSets) {
          @for (resultSet of resultSets; track trackByFn($index, resultSet)) {
            <mat-optgroup class="mt-2 flex items-center px-2">
              <span class="text-secondary text-sm font-semibold tracking-wider">
                {{ resultSet.label.toUpperCase() }}
              </span>
            </mat-optgroup>

            @for (result of resultSet.results; track trackByFn($index, result)) {
              <mat-option
                class="group relative mb-1 rounded-md px-6 py-0 text-md dark:hover:bg-hover hover:bg-gray-100"
                [routerLink]="result.link"
                [value]="result.value"
                (onSelectionChange)="close()"
              >
                <ng-container *ngTemplateOutlet="pageResult; context: { $implicit: result }"></ng-container>
              </mat-option>
            }
          }
        }
      </mat-autocomplete>

      <button class="absolute right-5 top-1/2 -mt-5 h-10 w-10 shrink-0 sm:right-7" mat-icon-button (click)="close()">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>
  }
}

<!-- Basic search -->
@if (appearance === 'basic') {
  <div class="w-full sm:min-w-80">
    <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
      <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>

      <input matInput [formControl]="searchControl" [matAutocomplete]="matAutocomplete" [placeholder]="'Search...'" (keydown)="onKeydown($event)" />
    </mat-form-field>

    <mat-autocomplete class="mt-1 max-h-128 rounded" [autoSelectActiveOption]="true" [disableRipple]="true" #matAutocomplete="matAutocomplete">
      @if (resultSets && !resultSets.length) {
        <mat-option class="text-secondary pointer-events-none bg-transparent px-6 py-0 text-md">No results found!</mat-option>
      }

      @if (resultSets) {
        @for (resultSet of resultSets; track trackByFn($index, resultSet)) {
          <mat-optgroup class="mt-2 flex items-center px-2">
            <span class="text-secondary text-sm font-semibold tracking-wider">
              {{ resultSet.label.toUpperCase() }}
            </span>
          </mat-optgroup>

          @for (result of resultSet.results; track trackByFn($index, result)) {
            <mat-option
              class="group relative mb-1 rounded-md px-6 py-0 text-md dark:hover:bg-hover hover:bg-gray-100"
              [routerLink]="result.link"
              [value]="result.value"
            >
              <ng-container *ngTemplateOutlet="pageResult; context: { $implicit: result }"></ng-container>
            </mat-option>
          }
        }
      }
    </mat-autocomplete>
  </div>
}

<!-- Page result template -->
<ng-template #pageResult let-result>
  <div class="flex flex-col py-2">
    <div class="truncate font-medium leading-normal">
      {{ result.title }}
    </div>
    <div class="text-secondary truncate text-sm leading-normal">
      {{ result.subtitle || result.link }}
    </div>
  </div>
</ng-template>
